import { generateUtilityClasses } from './generateUtilityClasses';

export const createUtilityClasses = (accessKeys) => (props) => Object.entries(props)
  .filter(([key]) => accessKeys.includes(key))
  .flatMap(([key, value]) => generateUtilityClasses(value, key));
